import { dateProvider } from '@utils';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ShowInformation } from '../../../ShowInformation';
import { ProgressTip } from '../ProgressTip';
import { ProgressWithPlanificationGraph } from '../ProgressWithPlanificationGraph';

import { InformationWrapper, Wrapper } from './AllPlanification.styles';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { useMyPlanification, useMyPlanificationProgress } from '@/store';

const formatTimeFromMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);

  const mins = Math.floor(minutes % 60);

  const formatedTime: string[] = [];

  if (hours > 0) formatedTime.push(`${hours}h`);

  if (mins > 0) formatedTime.push(`${mins}m`);

  return formatedTime.join(' ') || '0m';
};

export const AllPlanification = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const { planification, isLoading: isPlanificationLoading } = useMyPlanification();
  const { planificationProgress, isPending } = useMyPlanificationProgress();
  const { colors } = useTheme();
  if (!planification || !planificationProgress) return null;

  return (
    <Wrapper>
      {isPlanificationLoading || isPending ? (
        <LoadingCircleSpinner />
      ) : (
        <>
          <InformationWrapper>
            <ProgressTip planificationProgress={planificationProgress} />
            <ProgressWithPlanificationGraph
              planification={planification}
              planificationProgress={planificationProgress}
              isPending={false}
              colors={colors}
              t={t}
            />
            <ShowInformation
              icon={'ChartLine'}
              bigLabel={t('TOTAL_PROGRESS')}
              smallLabel={t('IDEAL_PROGRESS')}
              bigPercentage={`${planificationProgress?.currentProgress.toFixed(1)}%`}
              smallPercentage={<span>{planificationProgress?.idealProgress.toFixed(1)}%</span>}
            />
            <ShowInformation
              icon={'Time'}
              bigLabel={t('STUDY_HOURS')}
              smallLabel={t('RECOMMENDED')}
              bigPercentage={formatTimeFromMinutes(planificationProgress.currentTimeMinutes)}
              smallPercentage={
                <span>{formatTimeFromMinutes(planificationProgress.recommendedTimeMinutes)}</span>
              }
            />
            <ShowInformation
              icon={'Event'}
              bigLabel={t('END_DATE')}
              smallLabel={t('REMAINING_DAYS')}
              bigPercentage={dateProvider.format(
                dateProvider.parse(planification.endDate),
                'dd MMM yyyy'
              )}
              smallPercentage={
                <span>
                  {planificationProgress.remainingDays}{' '}
                  {t('DAYS', { count: planificationProgress.remainingDays })}
                </span>
              }
            />
          </InformationWrapper>
        </>
      )}
    </Wrapper>
  );
};
